import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Card, Col, Row } from 'react-bootstrap';
import {
  Input,
  ActionButton,
  BackButton,
  DataStatus,
  Alert,
  SelectSearch,
  TextArea,
} from 'components';
import Axios from 'axios';
import {
  TableListTPFS,
  TableListTPLC,
  TableListTPMP,
  TableListTPBOP,
} from './Table';
import { TemplateLabourCostOnsiteApi } from 'api';
import { RupiahConvert } from 'utilities';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';

const TambahTemplatePenunjangProduksi = ({ setNavbarTitle }) => {
  const [isLoading, setIsLoading] = useState(false);

  // STATE DATA SATUAN
  const [detail, setDetail] = useState({});
  const [dataTPFS, setDataTPFS] = useState([]);
  const [dataTPLC, setDataTPLC] = useState([]);
  const [dataTPMP, setDataTPMP] = useState([]);
  const [dataTPBOP, setDataTPBOP] = useState([]);

  const [dataDropdown, setDataDropdown] = useState({
    tipe_prd: [],
    bentuk: [],
    lc: [],
    check: false,
  });

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: 'primary',
    text: '',
  });

  const history = useHistory();
  const { id } = useParams();

  const getInitialData = () => {
    setIsLoading(true);

    Axios.all([
      TemplateLabourCostOnsiteApi.getSingle({
        id_template_labour_cost_on_site: id,
      }),
      TemplateLabourCostOnsiteApi.getDropdown({ tipe: 'tipe_prd' }),
      TemplateLabourCostOnsiteApi.getDropdown({ tipe: 'bentuk' }),
      TemplateLabourCostOnsiteApi.getDropdown({ tipe: 'lc' }),
    ])
      .then(
        Axios.spread((detail, tipe, bentuk, lc) => {
          const detailData = detail.data.data.detail ?? [];
          let detailLC = detailData.filter((val) => val.ref === 'lc');

          const Maping = (value) => {
            const final = [];
            value.map((val) => {
              final.push({
                id_item_buaso: val.id_item_buaso,
                kode_item_bahan: val.kode_item,
                nama_satuan: val.nama_satuan,
                nama_item: val.nama_item,
                qty: val.qty,
                unit_price: val.harga_satuan,
                konstanta: val.konstanta,
                ref: val.ref,
              });
            });

            return final;
          };

          setDetail(detail.data.data);
          setDataTPLC(Maping(detailData));
          setDataDropdown({
            ...dataDropdown,
            tipe_prd: tipe.data.data,
            bentuk: bentuk.data.data,
            lc: lc.data.data,
            check: true,
          });
        })
      )
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: 'danger',
          text: 'Data gagal dimuat!',
        });
        setDataDropdown({ ...dataDropdown, check: false });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getInitialData();
    setNavbarTitle('Detail Template Labour Cost On-SIte');
    return () => {};
  }, []);

  const getGrandTotal = () => {
    let totalTPLC = 0;

    dataTPLC.map((val) => {
      const total = Math.round(
        parseFloat(val.qty).toFixed(6) *
          parseInt(val.unit_price) *
          parseFloat(val.konstanta).toFixed(6)
      );
      totalTPLC = parseInt(totalTPLC) + parseInt(total);
    });

    const grandTotal = parseInt(totalTPLC);

    return RupiahConvert(grandTotal.toString()).detail;
  };

  const GrandTotalSection = () => (
    <div className="p-2 bg-white text-right border">
      <b className="text-nowrap pr-3" style={{ fontSize: '14px' }}>
        Grand Total : {getGrandTotal()}
      </b>
    </div>
  );

  const mappingTP = (value) => {
    const final = [];
    value.map((val) => {
      final.push({
        id_item_buaso: val.id_item_buaso,
        qty: val.qty,
        harga_satuan: val.unit_price,
        konstanta: val.konstanta,
        ref: val.ref,
      });
    });

    return final;
  };

  const formInitialValues = {
    id_barang_jadi_tipe_produksi: detail.id_barang_jadi_tipe_produksi ?? '-',
    nama_barang_jadi_tipe_produksi:
      detail.nama_barang_jadi_tipe_produksi ?? '-',
    id_barang_jadi_bentuk: detail.id_barang_jadi_bentuk ?? '-',
    nama_barang_jadi_bentuk: detail.nama_barang_jadi_bentuk ?? '-',
    keterangan: detail.keterangan ?? '-',
  };

  const formValidationSchema = Yup.object().shape({
    id_barang_jadi_tipe_produksi: Yup.string().required(
      'Masukan Tipe Produksi'
    ),
    id_barang_jadi_bentuk: Yup.string().required('Masukan Bentuk'),
    id_barang_jadi_ukuran: Yup.string().required('Masukan Ukuran'),
  });

  const formSubmitHandler = (values) => {
    const analisaFinTpLc = mappingTP(dataTPLC);
    const finalValues = {
      ...values,
      detail: [...analisaFinTpLc],
    };

    TemplateLabourCostOnsiteApi.create(finalValues)
      .then((res) => {
        setAlertConfig({
          variant: 'primary',
          text: `Tambah data berhasil! `,
        });
        history.push('/master/template-penunjang-produksi', {
          alert: {
            show: true,
            variant: 'primary',
            text: 'Tambah Data Berhasil',
          },
        });
      })
      .catch((err) => {
        // ERROR ALERT
        setAlertConfig({
          variant: 'danger',
          text: err.response.data.message,
          show: true,
        });
      })
      .finally(() => {});
  };

  return (
    <>
      {isLoading ? (
        <DataStatus text="Memuat Data" loading={true} />
      ) : dataDropdown.check === true ? (
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="d-flex justify-content-between align-items-center ml-2 mb-2">
                <b>Detail Data Template Labour Cost On-SIte</b>
                <BackButton onClick={() => history.goBack()} />
              </div>
              <Card>
                <Card.Body>
                  <Alert
                    show={alertConfig.show}
                    variant={alertConfig.variant}
                    text={alertConfig.text}
                    showCloseButton={true}
                    onClose={() => {
                      setAlertConfig({
                        ...alertConfig,
                        show: false,
                      });
                    }}
                  />
                  <Row className="mb-2">
                    <Col lg="6">
                      <SelectSearch
                        label="Tipe Produksi"
                        name="id_barang_jadi_tipe_produksi"
                        placeholder="Pilih Tipe Produksi"
                        isDisabled={true}
                        option={dataDropdown.tipe_prd.map((val) => {
                          return {
                            value: val.id_barang_jadi_tipe_produksi,
                            label: val.nama_barang_jadi_tipe_produksi,
                          };
                        })}
                        onChange={(e) => {
                          setFieldValue(
                            'id_barang_jadi_tipe_produksi',
                            e.value
                          );
                        }}
                        defaultValue={{
                          value: values.id_barang_jadi_tipe_produksi,
                          label: values.nama_barang_jadi_tipe_produksi,
                        }}
                        error={
                          errors.id_barang_jadi_tipe_produksi &&
                          touched.id_barang_jadi_tipe_produksi &&
                          true
                        }
                        errorText={
                          errors.id_barang_jadi_tipe_produksi &&
                          touched.id_barang_jadi_tipe_produksi &&
                          errors.id_barang_jadi_tipe_produksi
                        }
                      />
                    </Col>
                    <Col lg="6">
                      <SelectSearch
                        label="Bentuk"
                        name="id_barang_jadi_bentuk"
                        placeholder="Pilih Bentuk"
                        isDisabled={true}
                        option={dataDropdown.bentuk.map((val) => {
                          return {
                            value: val.id_barang_jadi_bentuk,
                            label: val.nama_barang_jadi_bentuk,
                          };
                        })}
                        onChange={(e) => {
                          setFieldValue('id_barang_jadi_bentuk', e.value);
                        }}
                        defaultValue={{
                          value: values.id_barang_jadi_bentuk,
                          label: values.nama_barang_jadi_bentuk,
                        }}
                        error={
                          errors.id_barang_jadi_bentuk &&
                          touched.id_barang_jadi_bentuk &&
                          true
                        }
                        errorText={
                          errors.id_barang_jadi_bentuk &&
                          touched.id_barang_jadi_bentuk &&
                          errors.id_barang_jadi_bentuk
                        }
                      />
                    </Col>
                  </Row>
                  <TextArea
                    label="Keterangan"
                    placeholder="Masukan Keterangan"
                    value={values.keterangan}
                    disabled={true}
                    rows={3}
                    onChange={handleChange}
                  />
                </Card.Body>
              </Card>
              <div className="d-flex justify-content-between align-items-center ml-2 mb-2 mt-4">
                <b>Data Template Labour Cost On-Site</b>
              </div>
              <Card>
                <Card.Body>
                  <TableListTPLC
                    dataSelectTPLC={dataDropdown.lc}
                    dataTPLC={dataTPLC}
                    setDataTPLC={setDataTPLC}
                  />
                </Card.Body>
              </Card>
            </form>
          )}
        </Formik>
      ) : (
        <DataStatus text="Data Tidak Ada" />
      )}
    </>
  );
};

export default TambahTemplatePenunjangProduksi;
